import React, { useState, useRef, useEffect } from "react";
import { DateRangePicker } from "react-date-range";
import { formatDate, useOutsideClick } from "../../utils/helper";

const DateRangeSelector = ({
    dateRangeData,
    setDateRangeData,
    label = "Date Range", // Default label
    placeholder = "Select Date Range", // Default placeholder
    maxDate = null, // Default max date (today)
    minDate = null, // Default min date (none)
    dateFormat = "MM/dd/yyyy", // Default date format
    onReset = () => { }, // Reset function
    onClose = () => { }, // Close function
    showDateRangePreview = true, // Whether to show date range preview
}) => {
    const [showDatePicker, setShowDatePicker] = useState(false);
    const datePickerRef = useRef(null);

    // Close date picker when clicking outside
    useOutsideClick(datePickerRef, () => setShowDatePicker(false));

    useEffect(() => {
        // Automatically close the date picker when criteria are updated
        if (dateRangeData.startDate && dateRangeData.endDate) {
            setShowDatePicker(false);
        }
    }, [dateRangeData]);

    const handleDateChange = (ranges) => {
        const { startDate, endDate } = ranges.selection;
        setDateRangeData({
            startDate,
            endDate
        });
        setShowDatePicker(false);
    };

    const handleReset = () => {
        setDateRangeData({
            startDate: null,
            endDate: null
        });
        onReset();
    };

    return (
        <div className="relative">
            <label htmlFor="date-range" className="text-sm">
                {label}
            </label>
            <input
                type="text"
                id="date-range"
                className="relative w-full rounded-md text-shoorah-sidebarBackground cursor-pointer border border-gray-300  bg-white dark:border-none  dark:bg-shoorah-darkBgColor dark:text-white py-2 pl-3 pr-6 text-left  focus:outline-none sm:text-sm"
                placeholder={placeholder}
                value={
                    dateRangeData.startDate && dateRangeData.endDate
                        ? `${formatDate(dateRangeData.startDate, dateFormat)} - ${formatDate(dateRangeData.endDate, dateFormat)}`
                        : ""
                }
                onClick={() => setShowDatePicker(true)}
                readOnly
            />
            {showDatePicker && (
                <div ref={datePickerRef} className="absolute z-10 mt-2 bg-white shadow-lg rounded-md">
                    <DateRangePicker
                        ranges={[{
                            startDate: dateRangeData.startDate || new Date(),
                            endDate: dateRangeData.endDate || new Date(),
                            key: "selection",
                        }]}
                        onChange={handleDateChange}
                        showSelectionPreview={showDateRangePreview}
                        moveRangeOnFirstSelection={false}
                        direction="horizontal"
                        {...(maxDate && { maxDate })}
                        {...(minDate && { minDate })}
                    />
                </div>
            )}
            {/* Optional Reset and Close Buttons */}
            {/* {(dateRangeData.startDate || dateRangeData.endDate) && (
                <div className="absolute top-1 right-1 flex space-x-2">
                    <button
                        type="button"
                        className="text-xs text-gray-500"
                        onClick={handleReset}
                    >
                        Reset
                    </button>
                    <button
                        type="button"
                        className="text-xs text-gray-500"
                        onClick={onClose}
                    >
                        Close
                    </button>
                </div>
            )} */}
        </div>
    );
};

export default DateRangeSelector;
